<template>
  <el-drawer
    :title="title"
    :visible.sync="drawer"
    :direction="direction"
    :before-close="handleClose"
  >
    <slot></slot>
  </el-drawer>
</template>
<script>
export default {
  name: 'EDrawer',
  props: {
    title: {
      type: String,
      default: ''
    },
    direction: {
      type: String,
      default: 'rtl'
    }
  },
  data() {
    return {
      drawer: false
    };
  },
  methods: {
    open() {
      this.drawer = true;
    },
    close() {
      this.drawer = false;
    },
    handleClose() {
      this.close();
    }
  }
};
</script>
<style lang="less">
.el-drawer__header {
  border-bottom: 1px solid @border-color;
  padding: 20px;
  margin-bottom: 0;
  span {
    color: @title-color;
    font-weight: bold;
  }
}
.el-drawer__body {
  padding: 20px;
}
</style>
